import isoLangs from "@/iso-langs.json";

// get locale
import { i18n } from "./main";

// function to format a date
function toDate(date) {
  try {
    return date.toDate();
  } catch (_error) {
    if (date instanceof Date) {
      return date;
    }
    return new Date();
  }
}

// function to get the lang code of the iso
function convertLangCode(langCode) {
  let lang = isoLangs[langCode];
  if (lang) {
    if (lang["639-1"]) {
      return lang["639-1"];
    }
  }
  return langCode;
}

// function to check if userPositon should get billed
function isUserPositionBilled(event) {
  if (event.eventType === "livestream") {
    return false;
  }
  if (event.eventType === "hybrid" && (event.hybridType === "livestream" || event.hybridType === "audiotrack")) {
    return false;
  }
  return true;
}

// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// extra spacing to start fucntion at same line as in functions so comparement is easier
export const generateBillByData = function (organization, event) {
  // -
  // -
  // extra spacing to start fucntion at same line as in functions so comparement is easier

  const moment = require("moment");

  // current vat
  let VAT = 0.16;

  // default conditions
  const conditions_defaults = {
    currency: "EUR",
    perLangCombPerHour: 50,
    minHours: 0,
    perAudioParticipantPerDay: 1.0,
    perAudioParticipantPerHalfADay: 0.5,
    perVideoParticipantPerDay: 3.0,
    perVideoParticipantPerHalfADay: 1.5,
    techSupportPerHour: 80,
  };

  // hour discount which gets applied later
  const hourDiscount = [
    1, // 0 hour / 0 days
    1, // 1 hour / 0 days
    1, // 2 hour / 0 days
    1, // 3 hour / 0 days
    1, // 4 hour / 0 days
    0.7, // 5 hour / 0 days
    0.7, // 6 hour / 0 days
    0.7, // 7 hour / 0 days
    0.7, // 8 hour / 1 days
    0.5, // 9 hour / 1 days
    0.5, // 10 hour / 1 days
    0.5, // 11 hour / 1 days
    0.5, // 12 hour / 1 days
    0.5, // 13 hour / 1 days
    0.5, // 14 hour / 1 days
    0.5, // 15 hour / 1 days
    0.5, // 16 hour / 2 days
    0.45, // 17 hour / 2 days
    0.45, // 18 hour / 2 days
    0.45, // 19 hour / 2 days
    0.45, // 20 hour / 2 days
    0.45, // 21 hour / 2 days
    0.45, // 22 hour / 2 days
    0.45, // 23 hour / 2 days
    0.45, // 24 hour / 3 days
    0.35, // 25 hour / 3 days
    0.35, // 26 hour / 3 days
    0.35, // 27 hour / 3 days
    0.35, // 28 hour / 3 days
    0.35, // 29 hour / 3 days
    0.35, // 30 hour / 3 days
    0.35, // 31 hour / 3 days
    0.35, // 32 hour / 4 days
    0.3, // 33 hour / 4 days
    0.3, // 34 hour / 4 days
    0.3, // 35 hour / 4 days
    0.3, // 36 hour / 4 days
    0.3, // 37 hour / 4 days
    0.3, // 38 hour / 4 days
    0.3, // 39 hour / 4 days
    0.3, // 40 hour / 5 days
    0.27, // 41 hour / 5 days
    0.27, // 42 hour / 5 days
    0.27, // 43 hour / 5 days
    0.27, // 44 hour / 5 days
    0.27, // 45 hour / 5 days
    0.27, // 46 hour / 5 days
    0.27, // 47 hour / 5 days
    0.27, // 48 hour / 6 days
    0.25, // 49 hour / 6 days
    0.25, // 50 hour / 6 days
    0.25, // 51 hour / 6 days
    0.25, // 52 hour / 6 days
    0.25, // 53 hour / 6 days
    0.25, // 54 hour / 6 days
    0.25, // 55 hour / 6 days
    0.25, // 56 hour / 7 days
    0.23, // 57 hour / 7 days
    0.23, // 58 hour / 7 days
    0.23, // 59 hour / 7 days
    0.23, // 60 hour / 7 days
    0.23, // 61 hour / 7 days
    0.23, // 62 hour / 7 days
    0.23, // 63 hour / 7 days
    0.23, // 64 hour / 8 days
    0.22, // 65 hour / 8 days
    0.22, // 66 hour / 8 days
    0.22, // 67 hour / 8 days
    0.22, // 68 hour / 8 days
    0.22, // 69 hour / 8 days
    0.22, // 70 hour / 8 days
    0.22, // 71 hour / 8 days
    0.22, // 72 hour / 8 days
    0.22, // 73 hour / 8 days
    0.22, // 74 hour / 8 days
    0.22, // 75 hour / 8 days
    0.22, // 76 hour / 8 days
    0.22, // 77 hour / 8 days
    0.22, // 78 hour / 8 days
    0.22, // 79 hour / 8 days
    0.22, // 80 hour / 8 days
    0.21, // 81 hour / 8 days
    0.21, // 82 hour / 8 days
    0.21, // 83 hour / 8 days
    0.21, // 84 hour / 8 days
    0.21, // 85 hour / 8 days
    0.21, // 86 hour / 8 days
    0.21, // 87 hour / 8 days
    0.21, // 88 hour / 8 days
    0.21, // 89 hour / 8 days
    0.21, // 90 hour / 8 days
    0.21, // 91 hour / 8 days
    0.21, // 92 hour / 8 days
    0.21, // 93 hour / 8 days
    0.21, // 94 hour / 8 days
    0.21, // 95 hour / 8 days
    0.21, // 96 hour / 8 days
    0.2, // 97 hour / 8 days
    0.2, // 98 hour / 8 days
    0.2, // 99 hour / 8 days
    0.2, // 100 hour / 8 days
    0.2, // 101 hour / 8 days
    0.2, // 102 hour / 8 days
    0.2, // 103 hour / 8 days
    0.2, // 104 hour / 8 days
    0.2, // 105 hour / 8 days
    0.2, // 106 hour / 8 days
    0.2, // 107 hour / 8 days
    0.2, // 108 hour / 8 days
    0.2, // 109 hour / 8 days
    0.2, // 110 hour / 8 days
    0.2, // 111 hour / 8 days
    0.2, // 112 hour / 8 days
    0.19, // 113 hour / 8 days
    0.19, // 114 hour / 8 days
    0.19, // 115 hour / 8 days
    0.19, // 116 hour / 8 days
    0.19, // 117 hour / 8 days
    0.19, // 118 hour / 8 days
    0.19, // 119 hour / 8 days
    0.19, // 120 hour / 8 days
  ];

  // lang discount which gets applied later
  const langDiscount = [
    1, // 0 langs
    1, // 1 langs
    0.7, // 2 langs
    0.6, // 3 langs
    0.55, // 4 langs
    0.5, // 5 langs
    0.48, // 6 langs
    0.45, // 7 langs
    0.4, // 8 langs
    0.38, // 9 langs
    0.35, // 10 langs
    0.3, // 11 langs
    0.28, // 12 langs
    0.25, // 13 langs
    0.2, // 14 langs
    0.2, // 15 langs
    0.2, // 16 langs
    0.2, // 17 langs
    0.2, // 18 langs
    0.2, // 19 langs
  ];

  // array of the exchange rates
  const exchangeRates = {
    EUR: 1.0,
    USD: 1.11,
    JPY: 133.0,
    CNY: 7.1,
    GBP: 0.85,
    SAR: 5.0,
    AED: 4.5,
    ARS: 100.0,
    BRL: 5.8,
    DKK: 7.45,
    HKD: 8.6,
    INR: 85.0,
    ILS: 3.7,
    KWD: 0.4,
    CHF: 1.05,
    SEK: 10.88,
    RUB: 120.0,
    NOK: 10.2,
    CAD: 1.45,
    AUD: 1.6,
  };
  // error var to break loop if needed
  var errorFlag = false;

  try {
    // convert start- and endtimes to correct format
    let startTime;
    let endTime;
    try {
      startTime = toDate(event.startTime);
      endTime = toDate(event.endTime);
    } catch (_error) {
      errorFlag = true;
      startTime = new Date();
      endTime = new Date();
    }

    // get max participants of the event
    let maxParticipants;
    try {
      maxParticipants = event.maxParticipants;
    } catch (_error) {
      errorFlag = true;
      maxParticipants = 0;
    }

    // set all the billing positions
    let title = [];
    let userPositions = [];
    let langPositions = [];
    let livestreamPositions = [];
    let recordingPositions = [];
    let interpretingPositions = [];

    // get conditions from organization or get fallback
    let conditions = organization.conditions || conditions_defaults;

    // get the operating hours of the event
    let operatingHours;
    try {
      let operatingHoursArray = event.eventTimes.map((y) => {
        let startTime = toDate(y.startTime);
        let endTime = toDate(y.endTime);
        return moment(endTime).diff(startTime, "minutes");
      });
      // sum up and convert to rounded up hours
      operatingHours = operatingHoursArray.reduce((acc, duration) => acc + duration);
      operatingHours = Math.ceil(operatingHours / 60);
    } catch (_error) {
      errorFlag = true;
      operatingHours = 0;
    }

    // set title of the bill depending on the duration of the event
    let titleDesc = "";
    if (endTime) {
      if (startTime.toLocaleDateString("de-DE") == endTime.toLocaleDateString("de-DE")) {
        titleDesc = i18n.t("titleDescOneDay", {
          n: event.name,
          d: startTime.toLocaleDateString("de-DE"),
        });
      } else {
        titleDesc = i18n.t("titleDescMultipleDays", {
          n: event.name,
          s: startTime.toLocaleDateString("de-DE"),
          e: endTime.toLocaleDateString("de-DE"),
        });
      }
    }

    // push the desc to the bill without any titel as a header
    title.push({
      amount: 0,
      title: "",
      desc: titleDesc,
    });

    // get the applied discounts of the event as a const
    const AppliedHourDiscount = Number(
      (hourDiscount[operatingHours] || hourDiscount[hourDiscount.length - 1]).toFixed(3),
    );
    const AppliedLangDiscount = Number((langDiscount[event.langComb.length] || langDiscount.length - 1).toFixed(3));
    const AppliedTotalDiscount = Number((AppliedHourDiscount * AppliedLangDiscount).toFixed(3));

    // set correct condition for event to var modal
    let modal;
    if (event.isVideoEvent) {
      if (operatingHours <= 4) {
        modal = conditions.perVideoParticipantPerHalfADay;
      } else {
        modal = conditions.perVideoParticipantPerDay;
      }
    } else {
      if (operatingHours <= 4) {
        modal = conditions.perAudioParticipantPerHalfADay;
      } else {
        modal = conditions.perAudioParticipantPerDay;
      }
    }

    // get participant cost from operating hours, discounts and particpants
    let participantsAmount = Math.ceil(operatingHours / 8) * modal * maxParticipants;

    // get livestream cost from operating hours and particpants
    let livestreamDataInTB = (operatingHours * 2.4 * maxParticipants) / 1000;
    let livestreamCostPerGBinDollar = 0.04;
    let livestreamDiscount;
    if (livestreamDataInTB < 10) {
      livestreamDiscount = 1.8;
    } else if (livestreamDataInTB < 40) {
      livestreamDiscount = 1.6;
    } else if (livestreamDataInTB < 150) {
      livestreamDiscount = 1.5;
    } else {
      livestreamDiscount = 1.4;
    }

    // set desc of user postion in the bill
    let userPositionsDesc = "";
    if (event.isVideoEvent) {
      userPositionsDesc = i18n.t("userPositionsDescVideo", {
        p: maxParticipants,
        h: operatingHours,
      });
    } else {
      userPositionsDesc = i18n.t("userPositionsDescAudio", {
        p: maxParticipants,
        h: operatingHours,
      });
    }

    // if the event isnt a livestream, hybrid-livestream or hybrid-audiotrack then user postions gets pushed into the bill
    if (isUserPositionBilled(event)) {
      userPositions.push({
        amount: participantsAmount * AppliedHourDiscount,
        title: i18n.t("userPositionsTitle"),
        desc: userPositionsDesc,
      });
    }

    // only run if event has langs which should be recorded
    // push the lang which should be recorded to the recording postion and calculate the price
    if (event.recordLangs) {
      for (const value of Object.entries(event.recordLangs)) {
        if (value[1].record) {
          recordingPositions.push({
            amount: operatingHours * 5 * (exchangeRates[conditions.currency] || 1),
            title: i18n.t("soloRecordPositionsTitle", {
              l: convertLangCode(value[1].lang),
            }),
            desc: i18n.t("soloRecordPositionsDesc", {
              h: operatingHours,
            }),
          });
        }
      }
    }

    // only run if hybrid event
    // billing of the interpreting type
    if (event.eventType === "hybrid") {
      let interpretingAmount;
      // cost per particpant
      let interpretingModal;
      if (operatingHours <= 4) {
        interpretingModal = conditions.perAudioParticipantPerHalfADay;
      } else {
        interpretingModal = conditions.perAudioParticipantPerDay;
      }
      // calculate amount for interpreting particpants
      if (event.interpretingType === "device") {
        interpretingAmount = Math.ceil(operatingHours / 8) * interpretingModal * event.interpretingParticipants;
        interpretingPositions.push({
          amount: interpretingAmount * AppliedHourDiscount,
          title: i18n.t("interpretingPositionsTitle"),
          desc: i18n.t("interpretingPositionsDescDevice", {
            p: event.interpretingParticipants,
            h: operatingHours,
          }),
        });
        // calculate amount for each language
      } else {
        try {
          let langs = [];
          for (let langComb of event.langComb) {
            // check if lang comb is empty
            if (langComb.lang1 === "" || langComb.lang2 === "") {
              break;
            }

            langs.push(langComb.lang1);
            langs.push(langComb.lang2);
          }
          let uniqueLangs = [...new Set(langs)];
          interpretingAmount = Math.ceil(operatingHours / 8) * interpretingModal * uniqueLangs.length;
          // push device interpreting into bill
          interpretingPositions.push({
            amount: interpretingAmount * AppliedHourDiscount,
            title: i18n.t("interpretingPositionsTitle"),
            desc: i18n.t("interpretingPositionsDescExisting", {
              p: uniqueLangs.length,
              h: operatingHours,
            }),
          });
        } catch (_error) {
          errorFlag = true;
          console.log("no lang combinations");
        }
      }
    }

    // only run if event is livestream
    if (event.eventType === "livestream" || (event.eventType === "hybrid" && event.hybridType === "livestream")) {
      // push indipendent server cost
      livestreamPositions.push({
        amount: 50.0 * (exchangeRates[conditions.currency] || 1),
        title: i18n.t("livestreamPositionsTitle"),
        desc: i18n.t("livestreamPositionsDescServer"),
      });

      // get livestream cost
      let livestreamAmount;
      if (event.livestreamType == "player" || event.livestreamType == "pull") {
        // get amount for player and pull
        livestreamAmount = livestreamCostPerGBinDollar * livestreamDataInTB * 1000 * 0.9 * livestreamDiscount;

        // push into bill
        livestreamPositions.push({
          amount: livestreamAmount * (exchangeRates[conditions.currency] || 1),
          title: i18n.t("livestreamPositionsTitle"),
          desc: i18n.t("livestreamPositionsDesc", {
            p: maxParticipants,
            h: operatingHours,
            tb: livestreamDataInTB.toFixed(2),
          }),
        });
        // -
        // -
        // -
        // -
      } else {
        // get amount for livestream type target
        try {
          let langs = [];
          for (let langComb of event.langComb) {
            // check if lang comb is empty
            if (langComb.lang1 === "" || langComb.lang2 === "") {
              break;
            }

            langs.push(langComb.lang1);
            langs.push(langComb.lang2);
          }
          let uniqueLangs = [...new Set(langs)];
          for (let lang of uniqueLangs) {
            livestreamPositions.push({
              amount: operatingHours * 5 * (exchangeRates[conditions.currency] || 1),
              title: i18n.t("soloLivestreamPositionsTitle", {
                l: convertLangCode(lang),
              }),
              desc: i18n.t("soloLivestreamPositionsDesc", {
                h: operatingHours,
              }),
            });
          }
          // -
        } catch (_error) {
          errorFlag = true;
          console.log("no lang combinations");
        }
      }
    }

    // calculate the language combinations cost
    try {
      for (let langComb of event.langComb) {
        if (langComb.lang1 === "" || langComb.lang2 === "") {
          break;
        }
        let langHours = 0;

        // set correct lang hours
        if (langComb.timed && Array.isArray(langComb.timeslots) && langComb.timeslots.length > 0) {
          let langCombArray = langComb.timeslots.map((y) => {
            let startTime = toDate(y.startTime);
            let endTime = toDate(y.endTime);
            return moment(endTime).diff(startTime, "minutes");
          });
          // sum up and convert to rounded up hours
          langHours = langCombArray.reduce((acc, duration) => acc + duration);
          langHours = Math.ceil(langHours / 60);
        } else {
          langHours = operatingHours;
        }

        // set the lang position desc depending on the combination type of the langs
        let langPositionsDesc = "";
        if (langComb.mono) {
          langPositionsDesc = i18n.t("langPositionsDesc", {
            l1: convertLangCode(langComb.lang1),
            l2: convertLangCode(langComb.lang2),
            a: "↦",
            h: langHours,
          });
        } else {
          langPositionsDesc = i18n.t("langPositionsDesc", {
            l1: convertLangCode(langComb.lang1),
            l2: convertLangCode(langComb.lang2),
            a: "⇄",
            h: langHours,
          });
        }

        // push the lang comb to the bill
        langPositions.push({
          amount: conditions.perLangCombPerHour * langHours * AppliedTotalDiscount,
          title: `${convertLangCode(langComb.lang1)} ${langComb.mono ? "↦" : "⇄"} ${convertLangCode(langComb.lang2)}`,
          desc: langPositionsDesc,
        });
      }
    } catch (_error) {
      errorFlag = true;
      console.log("no lang combinations");
    }

    //let totalUserPositions = userPositions.reduce( (acc, position) => acc + position.amount, 0 )
    //let totalLangPositions = langPositions.reduce( (acc, position) => acc + position.amount, 0 )

    //let totalUserDiscount = Number ( (totalUserPositions * (1 - AppliedDayDiscount) * -1).toFixed(3) )
    //let totalLangDiscount = Number ( (totalLangPositions * (1 - AppliedTotalDiscount) * -1).toFixed(3) )

    /*if (totalUserDiscount < 0) {
      userPositions.push({ 
        amount: totalUserDiscount,
        discount: true,
        title: "Mehrtagesrabatt auf Teilnehmerkosten",
        desc: "Preisnachlass!"
      })
    } */

    /*if (totalLangDiscount < 0) {
      langPositions.push({ 
        amount: totalLangDiscount,
        discount: true,
        title: "Mehrtages- & Mehrsprachenrabatt auf Sprachkombinationen",
        desc: "Preisnachlass!"
      })
    }*/

    // concat all the positons of the bill
    let totalPositions = title.concat(
      userPositions.concat(
        langPositions.concat(livestreamPositions.concat(recordingPositions.concat(interpretingPositions))),
      ),
    );

    // push discount if the origanziaton is a boker
    if (organization.isBroker && organization.brokerApproved && organization.brokerSigned) {
      totalPositions.push({
        amount: totalPositions.reduce((acc, position) => acc + position.amount, 0) * 0.2 * -1,
        desc: i18n.t("totalPositionsBrokerDesc"),
        title: i18n.t("totalPositionsBrokerTitle"),
      });
    }

    // push the event tech support if option is selected
    if (event.techSupport) {
      totalPositions.push({
        amount: operatingHours * conditions.techSupportPerHour,
        desc: i18n.t("totalPositionsTechSupportDesc", { h: operatingHours }),
        title: i18n.t("totalPositionsTechSupportTitle"),
      });
    }

    if (event.isSubscriptionEvent) {
      let subscriptionDiscount = totalPositions.reduce((acc, position) => acc + position.amount, 0).toFixed(2) * -1;
      // add tech support back into the calculation
      if (event.techSupport) {
        subscriptionDiscount += operatingHours * conditions.techSupportPerHour;
      }
      // add recording back into the calculation
      if (event.recordLangs) {
        for (const value of Object.entries(event.recordLangs)) {
          if (value[1].record) {
            subscriptionDiscount += operatingHours * 5 * (exchangeRates[conditions.currency] || 1);
          }
        }
      }
      // add livestream back into the calculation
      if (event.eventType === "livestream" || (event.eventType === "hybrid" && event.hybridType === "livestream")) {
        // indipendent server cost
        subscriptionDiscount += 50.0 * (exchangeRates[conditions.currency] || 1);

        if (event.livestreamType == "player" || event.livestreamType == "pull") {
          let livestreamAmount = livestreamCostPerGBinDollar * livestreamDataInTB * 1000 * 0.9 * livestreamDiscount;
          subscriptionDiscount += livestreamAmount * (exchangeRates[conditions.currency] || 1);
        } else {
          try {
            let langs = [];
            for (let langComb of event.langComb) {
              // check if lang comb is empty
              if (langComb.lang1 === "" || langComb.lang2 === "") {
                break;
              }

              langs.push(langComb.lang1);
              langs.push(langComb.lang2);
            }
            let uniqueLangs = [...new Set(langs)];
            for (let lang of uniqueLangs) {
              lang;
              subscriptionDiscount += operatingHours * 20 * (exchangeRates[conditions.currency] || 1);
            }
            // -
          } catch (_error) {
            errorFlag = true;
            console.log("no lang combinations");
          }
        }
      }
      totalPositions.push({
        amount: subscriptionDiscount,
        desc: i18n.t("qondaSubscriberDesc"),
        title: i18n.t("qondaSubscriber"),
      });
    }

    // FINALIZE
    let amount = totalPositions.reduce((acc, position) => acc + position.amount, 0);

    // set vat up to orignial amount if event begins in the new year
    if (moment(startTime).isAfter(moment("2020-12-31"))) {
      VAT = 0.19;
    }

    // info for the organization if the org is not in germany
    if (organization.legalCountry !== "de") {
      totalPositions.push({
        amount: 0,
        desc: i18n.t("totalPositionsNotDeDesc"),
        title: i18n.t("totalPositionsNotDeTitle"),
      });
      VAT = 0;
    }

    // complete bill object
    let bill = {
      paymentState: "open",
      legalName: organization.legalName || "",
      legalStreetName: organization.legalStreetName || "",
      legalZipCode: organization.legalZipCode || "",
      legalCity: organization.legalCity || "",
      legalCountry: organization.legalCountry || "",
      paymentType: event.paymentMethod,
      amount: amount.toFixed(2),
      currency: conditions.currency,
      date: new Date(),
      positions: totalPositions,
      billPDF: "",
      billNote: event.billNote,
      vat: VAT,
    };

    // if something went wrong than push an "empty" object
    if (errorFlag) {
      return { amount: 0, positions: [] };
    }

    return bill;
  } catch (error) {
    // generate bill function failed somewhere
    console.error(error);
    return { amount: 0, positions: [] };
  }
};
